export const getCssPropertyInt = (element, property) =>
  parseInt(getComputedStyle(element).getPropertyValue(property) || 0, 10);
